import React from "react";
import { useOutletContext } from "react-router-dom";
import MySpace from "./components/Space/MySpace";
import LearnerContentFrame from "./components/LearnerContentFrame";

const MySpacePage = () => {
  const { layoutPhase } = useOutletContext();

  return (
    <LearnerContentFrame layoutPhase={layoutPhase}>
      <MySpace />
    </LearnerContentFrame>
  );
};

export default MySpacePage;
